package ir.yusefpasha.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import ir.yusefpasha.components.AchievementCard
import ir.yusefpasha.models.Achievement
import ir.yusefpasha.models.Section
import ir.yusefpasha.models.Theme
import ir.yusefpasha.util.Constants
import ir.yusefpasha.util.ObserveViewportEntered
import ir.yusefpasha.util.animatedNumbers
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.px

@Composable
fun AchievementSection() {
    val breakpoint = rememberBreakpoint()
    Box(
        modifier = Modifier
            .id(Section.Achievements.id)
            .fillMaxWidth()
            .maxWidth(Constants.SECTION_WIDTH.px)
            .padding(topBottom = 150.px)
            .backgroundColor(Theme.LighterGray.rgb),
        contentAlignment = Alignment.Center
    ) {
        AchievementContent(breakpoint)
    }
}

@Composable
private fun AchievementContent(breakpoint: Breakpoint) {

    val scope = rememberCoroutineScope()

    var viewPortEntered by remember { mutableStateOf(false) }

    val animatedNumbers = remember { mutableStateListOf(0, 0, 0, 0) }

    ObserveViewportEntered(sectionId = Section.Achievements.id, distanceFromTop = 700.0) {
        viewPortEntered = true
        Achievement.values().forEach { achievement ->
            scope.launch {
                animatedNumbers(
                    number = achievement.number,
                    delay = 50L,
                    onUpdate = {
                        animatedNumbers[achievement.ordinal] = it
                    }
                )
            }
        }
    }

    SimpleGrid(numColumns = numColumns(base = 1, md = 2, lg = 4)) {
        Achievement.values().forEach { achievement ->
            AchievementCard(
                animatedNumber = if (viewPortEntered) animatedNumbers[achievement.ordinal] else 0,
                modifier = Modifier.margin(
                    right = if (achievement.ordinal == Achievement.values().lastIndex) {
                        0.px
                    } else {
                        if (breakpoint > Breakpoint.SM) 50.px else 0.px
                    },
                    bottom = if (breakpoint > Breakpoint.MD) 0.px else 40.px
                ),
                achievement = achievement
            )
        }
    }
}